module.exports = __webpack_public_path__ + "static/img/cinema-12.0bf7d73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/cinema-12.png
// module id = 1191
// module chunks = 173